import { Game } from './Game';

const game = new Game();
game.start();
